import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/commodity-plastics/re02.jpg")